import { AppConfig } from "../Config"

export interface NetgiroConfigI {
  netgiroUrl: string
}

export const NetgiroConfig: NetgiroConfigI = {
  netgiroUrl: AppConfig.netGiro.redirectUrl
}
